/** @format */

import React, {useState, useRef, useEffect} from 'react';
import {FormikControl, Form, Formik, Disclaimer} from '@home-loan-experts/ui-helper';
import PostcodeDetail from './PostcodeDetail';
import PostcodeEmail from './PostcodeEmail';
import {loaderConstants} from '../../constants';
import {validateSchema} from '../../utils/postcodeValidation';
import {disclaimer as DISCLAIMER_TEXT } from '../../constants';
import {calculatePostcode} from '../../actions';
import {useDispatch} from 'react-redux';
import {storage} from '../../constants';
import {initialValue} from '../../utils/postcodeOptions';
import EnquiryForm from './EnquiryForm';
import { eventTrackingHelper } from '../../utils/gtmTrackerHelper';

const PostcodeForm = () => {
    const [loader, setLoader] = useState({});
    //getting ref of result div
    const resultRef = useRef(null);
    const dispatch = useDispatch();
    const [timer, setTimer] = useState(null);

    const scrollToResult = () => {
        if (resultRef.current) {
            const resultPosition = resultRef.current.getBoundingClientRect().top + window.scrollY;
            const headerOffset = 190;

            window.scrollTo({
                top: resultPosition - headerOffset,
                behavior: 'smooth',
            });
        }
    };

    const handleSubmit = (values, { setSubmitting, ...props }) => {
        scrollToResult();
        setLoader(loaderConstants.CALCULATING);
        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        dispatch(calculatePostcode(values))
            .then(() => {
                //scrolling to result div as api returns result
            })
            .finally(() => {
                setSubmitting(false);
                eventTrackingHelper('calculation');
                setLoader(loaderConstants.CALCULATE);
                setTimer(
                    setTimeout(() => {
                        setLoader(loaderConstants.REMOVE_CALCULATE);
                    }, 6000)
                 );
            });
    };

    useEffect(() => {
        const value = localStorage.getItem(storage.INITIAL_VALUE);
        const reduxValue = localStorage.getItem(storage.POSTCODE_REDUX_STATE);
        if (!reduxValue || JSON.stringify(initialValue) !== value) {
            //required catch after fetch as test case throwed warning
            dispatch(calculatePostcode(initialValue)).catch((e) => {});
        }
    }, [dispatch]);

    return (
        <div className="calc-container">
            <h2 className="calc-title text-center text-bold">Postcode Calculator</h2>
            <div className="calc-form">
                <h4 className="text-bold  form-title title-dark">Fill in the details</h4>
                <div className="row ">
                    <Formik
                        initialValues={initialValue}
                        validationSchema={validateSchema}
                        onSubmit={handleSubmit}
                    >
                        {({errors, isSubmitting, isValid, setFieldValue}) => {
                            return (
                                <>
                                    <Form className="flex-row">
                                        <div className="col-md-8">
                                            <FormikControl
                                                control="numeric"
                                                isThousandSeparator={false}
                                                prefix={''}
                                                suffix={''}
                                                errors={errors}
                                                label="Postcode"
                                                name="postcode"
                                                className="form-control input-val"
                                                setFieldValue={setFieldValue}
                                            />
                                        </div>
                                        <div className="col-md-4 col-4 text-right">
                                            <button
                                                className="btn-blue btn loading-btn calculate-btn"
                                                disabled={isSubmitting || !isValid}
                                                type="submit"
                                            >Calculate
                                            </button>
                                        </div>
                                    </Form>
                                </>
                            );
                        }}
                    </Formik>
                </div>
            </div>            
            <PostcodeDetail resultRef={resultRef} loader={loader} />
            <div className="enquiry-container">
               <div className='enquiry-container--grid border-bottom-dashed'>
               <EnquiryForm />
               <PostcodeEmail />
               </div>
               <div className='text-disclaimer'>
                <Disclaimer disclaimerText={DISCLAIMER_TEXT} />
               </div>

            </div>
        </div>
    );
};

export default PostcodeForm;
